export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-fr-FR.7e3a4440.xlsx";